import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import ArrowDropUp from '@material-ui/icons/ArrowDropUp'
import Remove from '@material-ui/icons/Remove'
import { find, values } from 'lodash'
import React, { Fragment, PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import {
  dangerColor,
  primaryColor,
  successColor,
} from '../../assets/jss/material-kit-pro-react'
import Info from '../Typography/Info'

const getPercentage = (prev24price, children) => {
  // console.log(prev24price)

  switch (true) {
    case prev24price > 0:
      return (
        <TickerPrice color={successColor}>
          <ArrowDropUp />
          {children.toFixed(2)}
        </TickerPrice>
      )
    case prev24price < 0:
      return (
        <TickerPrice color={dangerColor}>
          <ArrowDropDown />
          {children.toFixed(2)}
        </TickerPrice>
      )
    default:
      return (
        <TickerPrice color={successColor}>
          <Remove />%
        </TickerPrice>
      )
  }
}

export default class Ticker extends PureComponent {
  componentDidMount() {
    const approvedProducts = [
      'BNL',
      'BTC',
      'ETH',
      'LTC',
      'XRP',
      'EOS',
      'XLM',
      'XMR',
      'TRX',
      'DASH',
      'ZEC',
      'OMG',
      'REP',
      'GNT',
    ]
    this.AlphaPointAPI = new WebSocket('wss://api.bitnational.com/WSGateway/')
    this.AlphaPointAPI.onopen = () => {
      const payload = {
        OMSId: 1,
      }
      const frame = {
        m: 0,
        i: 44,
        n: 'GetInstruments',
        o: JSON.stringify(payload),
      }
      this.AlphaPointAPI.send(JSON.stringify(frame))
    }
    this.AlphaPointAPI.onmessage = res => {
      const data = JSON.parse(res.data)
      switch (data.n) {
        case 'GetInstruments':
          const products = JSON.parse(data.o)
          const cdnProducts = products.filter(function(prod) {
            return (
              prod.Product2Symbol === 'CAD' &&
              approvedProducts.indexOf(prod.Product1Symbol) != -1
            )
          })
          for (let idx = 0; idx < cdnProducts.length; idx++) {
            const payload = { OMSId: 1, Symbol: cdnProducts[idx].Symbol }
            const frame = {
              m: 0,
              i: idx * 2,
              n: 'SubscribeLevel1',
              o: JSON.stringify(payload),
            }
            this.AlphaPointAPI.send(JSON.stringify(frame))
          }
          this.products = cdnProducts
          break
        case 'SubscribeLevel1':
          // console.log('SubscribeLevel1', JSON.parse(data.o))
          const subscribeData = JSON.parse(data.o)
          const subscribeInfo = find(
            this.products,
            o => o.InstrumentId == subscribeData.InstrumentId
          )
          const subscribeImage = find(
            this.props.ticker,
            o => o.symbol == subscribeInfo.Product1Symbol
          )

          this.setState({
            [subscribeData.InstrumentId]: {
              ...subscribeData,
              ...subscribeInfo,
              ...subscribeImage,
            },
          })
        case 'Level1UpdateEvent':
          return () => {
            // console.log('Level1UpdateEvent', JSON.parse(data.o))
            const updateData = JSON.parse(data.o)
            const updateInfo = find(
              this.products,
              o => o.InstrumentId == updateData.InstrumentId
            )
            this.setState({
              [updateData.InstrumentId]: { ...updateData, ...updateInfo },
            })
          }
        default:
          break
      }
    }
  }

  componentWillUnmount() {
    this.AlphaPointAPI.close()
  }

  render() {
    const symbols = values(this.state)

    return (
      <TickerWrapper
        onClick={() => {
          if (typeof window !== 'undefined')
            window.location.href =
              'https://exchange.bitnational.com/?login=true'
        }}
      >
        <TickerGrid count={symbols.length}>
          <Tickers symbols={symbols} />
          <Tickers symbols={symbols} />
        </TickerGrid>
      </TickerWrapper>
    )
  }
}

const Tickers = ({ symbols }) => (
  <Fragment>
    {symbols.map(ticker => (
      <Tick
        image={ticker.image.publicURL}
        key={ticker.InstrumentId}
        price={ticker.LastTradedPx}
        high={ticker.SessionHigh}
        symbol={ticker.Symbol}
      />
    ))}
  </Fragment>
)

const Tick = ({ symbol, price, high, image }) => {
  // let previousPrice = price / (prev24price / 100 + 1)
  return (
    <TickerContainer>
      <img src={image} alt={symbol} />
      <CardInfo>
        <h6 style={{ color: 'white', marginRight: '1rem' }}>{symbol}</h6>
        <Info>{price && <h5>{`$${price}`}</h5>}</Info>
        <small style={{ color: 'white' }}>HIGH: ${high}</small>
      </CardInfo>
    </TickerContainer>
  )
}

const ticker = keyframes`
100% {
 transform: translate3d(-50%, 0, 0);
}
`

const TickerContainer = styled.div`
  display: flex;
  align-items: center;
  width: 15rem;
  height: 3.5rem;
  transform-origin: center;
  transition: 300ms;

  &:hover {
    transform: scale(1.65);

    /* &::after {
      content: 'Go To Exchange →';
      position: absolute;
      pointer-events: none;
      color: white;
      font-weight: 600;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
    } */
  }

  img {
    height: 28px;
    width: 28px;
    align-self: flex-start;

    @media screen and (max-width: 768px) {
      height: 20px;
      width: 20px;
    }
  }
  /* border-left: 3px solid rgba(255, 255, 255, 0.5); */
`

const TickerPrice = styled.span`
  color: ${p => p.color};
  display: inline-flex;
  align-items: center;
`

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0rem;
  padding: 1rem;
  justify-content: space-between;
  /* align-items: center; */

  h5,
  h6 {
    margin: 0;
  }
`

const TickerWrapper = styled.div`
  width: 100vw;
  overflow: hidden;
  box-sizing: content-box;
  background: ${primaryColor};
  cursor: pointer;
  padding: 1rem 0;

  /* &:hover {
    &::after {
      content: 'Go To Exchange →';
      position: absolute;
      pointer-events: none;
      color: white;
      font-weight: 600;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
    }
  } */
`

const TickerGrid = styled.div`
  display: flex;
  height: 100px;
  align-items: center;
  width: min-content;
  white-space: nowrap;
  box-sizing: content-box;
  animation: ${ticker} ${p => p.count * 5}s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`



// WEBPACK FOOTER //
// ./src/components/Ticker/index.jsx